import React, { Key, ReactNode, useCallback, useEffect, useState } from 'react';
import { Menu, MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArchiveIcon, CurrentMenuIcon } from '../../assets/image/svg';
import './style.scss';
import { useDispatch } from 'react-redux';
import { setBreadcrumb } from '../../store/bids';
import Icon from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: ReactNode,
  key: Key,
  icon?: ReactNode,
  children?: MenuItem[] | null,
  style?: boolean | { display: string },
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    style,
    type,
  } as MenuItem;
}


interface MenuComponentProps {
  collapsed: boolean;
}

const Index: React.FC<MenuComponentProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentKey, setCurrentKey] = useState<string | null>(null); // Начальное состояние null

  const items: MenuProps['items'] = [
    getItem(
      t('Current'),
      '1',
      <Icon component={CurrentMenuIcon} />,
      null,

    ),
    getItem(
      t('Archive'),
      '2',
      <Icon component={ArchiveIcon} />,
      null,
    ),
    getItem(
      t('City'),
      '3',
      <Icon component={ArchiveIcon} />,
      null,
    ),
    getItem(
      t('Country'),
      '4',
      <Icon component={ArchiveIcon} />,
      null,
    ),
  ];

  const handleClickMenu = useCallback((e: any) => {
    const title = e.domEvent.target.innerText;
    const key = e.key;

    dispatch(setBreadcrumb([{ title: t('Bids') }, { title: title}]));
    // Обновляем состояние
    setCurrentKey(key);

    // Сохраняем состояние в localStorage
    localStorage.setItem('_br', JSON.stringify([{ title: t('Bids') }, { title }]));
    localStorage.setItem('_cur', key);

    // Навигация
    if (key === '1') {
      navigate('/');
    }
    else if (key === '2') {
      navigate('/archive');
    }
    else if (key === '3') {
      navigate('/city');
    }
    else if (key === '4') {
      navigate('/country');
    }
  }, [navigate]);

  useEffect(() => {
    // Восстанавливаем состояние из localStorage при загрузке компонента
    const savedCurrentState = localStorage.getItem('_cur');

    if (savedCurrentState) {
      setCurrentKey(savedCurrentState);
    }
  }, []);

  return (
    <Menu
      mode="inline"
      selectedKeys={currentKey ? [currentKey] : []} // Пустой массив, если currentKey null
      style={{ background: '#FFFFFF' }}
      onClick={handleClickMenu}
      items={items}
    />
  );
};

export default Index;
